import getDomainSuffix from "utils/getDomainSuffix";

const domainSuffix = getDomainSuffix();

const neoauthBase = `https://login.${domainSuffix}/`;

const appUrl = `${window.location.protocol}//${window.location.host}/`;

const dashboard = `https://dashboard.${domainSuffix}/`;

const Settings = {
  authorizeUrl: `${neoauthBase}o/authorize/`,
  appUrl,
  clientId: import.meta.env.VITE_API_CLIENT_ID,
  dashboard,
  revokeToken: `${neoauthBase}o/revoke_token/`,
};

// Built on each call: the login sends the user back to the page they are on now.
// Encoded whole: an "&" in the path would otherwise start a new parameter.
export const getFullLoginUrl = (): string =>
  `${Settings.authorizeUrl}?response_type=token&client_id=${
    Settings.clientId
  }&scope=read&redirect_uri=${encodeURIComponent(
    `${Settings.appUrl}${window.location.pathname.substring(1)}${window.location.search}`,
  )}`;

export const queryParamsInUrl = (url: string, queryParams: string): string =>
  `${url}?${queryParams}`;

export default Settings;
